import { useEffect, useState, useRef } from 'react'
import { Tree, ITreeNode } from '@blueprintjs/core'
import { cloneDeep, isEmpty } from 'lodash'
import { IPortfolioRegion } from '@api'
import { mapLocationTreeContents, forEachNode, LocationTreeNodeT } from './utils'
import { useFloor } from '@providers/mapProvider'

const useLocationTreeContents = (regions: IPortfolioRegion[]) => {
  const { floorId } = useFloor()
  const [locationTreeNodes, setLocationTreeNodes] = useState<LocationTreeNodeT[]>([])

  // it's necessary to mutate the state
  const clonedLocationTreeNodes = cloneDeep(locationTreeNodes)

  const setLocationContents = (nodePath: number[], callback: (node: ITreeNode) => void): void => {
    // it mutates the clonedLocationTreeNodes object
    callback(Tree.nodeFromPath(nodePath, clonedLocationTreeNodes))

    setLocationTreeNodes(clonedLocationTreeNodes)
  }

  const setLocationContentsForEachNode = (callback: (node: LocationTreeNodeT) => void): void => {
    // it mutates the clonedLocationTreeNodes object
    forEachNode(callback, clonedLocationTreeNodes)

    setLocationTreeNodes(clonedLocationTreeNodes)
  }

  // init and floor change locationTreeNodes states
  useEffect(() => {
    if (isEmpty(regions)) {
      return
    }
    floorId && setLocationTreeNodes(mapLocationTreeContents(regions, floorId))
  }, [regions, floorId])

  return {
    locationTreeNodes,
    setLocationContents,
    setLocationContentsForEachNode,
    setLocationTreeNodes,
  }
}

export default useLocationTreeContents
